var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4395 0C16.3863 0.0738086 20.1489 1.57565 23.3018 4.56971C24.0175 5.25004 24.1763 5.97208 23.8089 6.68128C23.2665 7.72904 22.0455 7.8558 21.0699 6.93159C19.3804 5.33026 17.4373 4.17821 15.1604 3.66476C10.6036 2.63625 6.55853 3.65673 3.08792 6.81606C2.58891 7.27014 2.0546 7.75792 1.37588 7.5028C0.894524 7.32149 0.3907 6.90752 0.15002 6.45985C-0.182118 5.84532 0.0697937 5.19869 0.586454 4.69326C2.79429 2.53516 5.40006 1.08787 8.41177 0.430015C9.60073 0.170081 10.825 0.0850403 11.4395 0Z",
    fill: "#5ABA20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9578 7.08405C14.4079 7.12255 16.5066 7.93766 18.2845 9.55824C19.1317 10.33 19.2392 11.2542 18.599 11.9971C17.978 12.716 16.9864 12.7224 16.1456 12.0116C13.5014 9.77646 10.5265 9.77164 7.89992 11.9971C7.0431 12.724 6.07878 12.7288 5.44338 12.0132C4.79034 11.2767 4.88821 10.3525 5.73059 9.57589C7.49879 7.94568 9.59912 7.13379 11.9578 7.08405Z",
    fill: "#5ABA20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99544 16.3374C9.97458 15.2142 10.8394 14.3013 11.9514 14.2708C13.1034 14.2403 14.0325 15.1436 14.0341 16.2957C14.0341 17.406 13.1355 18.3206 12.0332 18.3334C10.9309 18.3463 10.0147 17.4494 9.99544 16.3374Z",
    fill: "#5ABA20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.cef6c4b3323611da11a1847a55e6c2f0.svg";
export { ForwardRef as ReactComponent };